import { get, writable } from "svelte/store";

import GeoHelper from "../../Helpers/GeoHelper";
import MapStore from "../../Map/Store";
import MapDataSource from "../../Map/Enums/MapDataSource";

import RoutePlot from "./RoutePlot";

const RoutePlottingStore = {
	meta: {
		lastUpdated: writable(0),
		visible: writable(false),
		activeTab: writable("")
	},
	inputs: {
		// plot: writable(new RoutePlot()),
		plots: writable([])
	},
	results: {

	},
	actions: {

	},
	helpers: {

	}
};
RoutePlottingStore.actions.add = () => {
	const plots = get(RoutePlottingStore.inputs.plots);
	plots.push(new RoutePlot());
	RoutePlottingStore.inputs.plots.set(plots);
	RoutePlottingStore.meta.lastUpdated.set(Date.now());
};
RoutePlottingStore.actions.clearAll = () => {
	RoutePlottingStore.inputs.plots.set([]);
	RoutePlottingStore.meta.lastUpdated.set(Date.now());
};
RoutePlottingStore.helpers.rebuildGeoJSON = () => {
	const featurePoints = GeoHelper.emptyGeoJson();
	const featureLines = GeoHelper.emptyGeoJson();
	const featureLabels = GeoHelper.emptyGeoJson();

	const plots = get(RoutePlottingStore.inputs.plots);
	for (let k = 0; k < plots.length; k++) {
		const plot = plots[k];
		const linePoints = plot.linePoints;
		featurePoints.features = [...featurePoints.features, ...GeoHelper.featureCollectionPoints(linePoints).features];
		featureLines.features.push(GeoHelper.featureLineString(linePoints));
		featureLines.features[featureLines.features.length - 1].properties.color = "black";

		// Build range rings
		const points = get(plot.points);
		for (let j = 0; j < points.length; j++) {
			const point = points[j];
			for (let i = 0; i < point.rangeRings.length; i++) {
				const arc = get(point.rangeRings[i].result.arc);
				if (arc) {
					featureLines.features.push(arc);
				}
				const label = get(point.rangeRings[i].result.label);
				if (label) {
					featureLabels.features.push(label);
				}
			}
		}
	}

	// Set lines on map
	const map = MapStore.helpers.getMap();
	const mapInitialised = get(MapStore.meta.initialised);
	if (map && mapInitialised) {
		map.getSource(MapDataSource.ROUTEPLOT_POINTS).setData(featurePoints);
		map.getSource(MapDataSource.ROUTEPLOT_POINT_LINES).setData(featureLines);
		map.getSource(MapDataSource.ROUTEPLOT_LABELS).setData(featureLabels);
	}
};
export default RoutePlottingStore;
